// import React from 'react';
// import { Upload, X, Loader2 } from 'lucide-react';

// const ImportCSVModal = ({
//   isOpen,
//   onClose,
//   onImport,
//   csvFile,
//   onFileUpload,
//   isImporting,
//   preview,
//   errors,
//   progress
// }) => {
//   if (!isOpen) return null;

//   const downloadTemplate = () => {
//     const csv = "user_name *,user_email,user_phone,user_department,user_roll *,managerId *,shift_start *,shift_end *,timezone,viewtimezone\nJohn Doe,john@company.com,9876543210,CSE,21BTCS0207,manager@email.com,09:00:00,18:00:00,Asia/Calcutta,Asia/Calcutta";
//     const blob = new Blob([csv], { type: 'text/csv' });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = 'user_import_template.csv';
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 bg-black/50 backdrop-blur-sm" onClick={!isImporting && onClose}>
//       <div className="bg-richblue-950 border border-blue-700/50 rounded-2xl w-full sm:max-w-4xl max-h-[92vh] overflow-y-auto sm:mb-0 mb-[70px]" onClick={(e) => e.stopPropagation()}>
//         <div className="sticky top-0 flex items-center justify-between p-5 border-b bg-richblue-950 border-blue-800/40">
//           <h2 className="flex items-center gap-2 text-xl font-bold text-white">
//             <Upload className="w-5 h-5 text-purple-500" /> Import Users from CSV
//           </h2>
//           <button onClick={onClose} disabled={isImporting} className="p-2 transition-colors rounded-lg hover:bg-blue-600/20">
//             <X className="w-5 h-5 text-blue-400" />
//           </button>
//         </div>

//         <div className="p-5 space-y-5">
//           <div className="p-4 border rounded-lg bg-blue-600/10 border-blue-700/50">
//             <p className="mb-2 text-sm text-blue-300">CSV Format Requirements:</p>
//             <p className="mb-2 text-xs text-gray-400">
//               Required columns: user_name, user_ID, managerId, shift_start, shift_end<br />
//               Optional columns: user_email, user_phone, user_department, timezone, viewtimezone<br />
//               Note: managerId can be Manager Email
//             </p>
//             <button
//               onClick={downloadTemplate}
//               className="px-3 py-1 text-sm text-purple-400 transition-colors rounded-lg bg-purple-600/20 hover:bg-purple-600/40"
//             >
//               Download CSV Template
//             </button>
//           </div>

//           <div>
//             <label className="block mb-2 text-sm font-medium text-blue-300">Upload CSV File</label>
//             <input
//               type="file"
//               accept=".csv"
//               onChange={onFileUpload}
//               disabled={isImporting}
//               className="w-full px-4 py-2 text-sm text-white border rounded-lg bg-richblue-900 border-blue-800/60 focus:outline-none file:mr-4 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-purple-600/20 file:text-purple-400 hover:file:bg-purple-600/40 disabled:opacity-50"
//             />
//           </div>

//           {isImporting && progress.total > 0 && (
//             <div className="space-y-2">
//               <div className="flex justify-between text-sm">
//                 <span className="text-blue-300">Importing users...</span>
//                 <span className="text-blue-300">{progress.current} / {progress.total}</span>
//               </div>
//               <div className="w-full h-2 rounded-full bg-richblue-900">
//                 <div
//                   className="h-2 transition-all duration-300 bg-purple-600 rounded-full"
//                   style={{ width: `${(progress.current / progress.total) * 100}%` }}
//                 />
//               </div>
//             </div>
//           )}

//           {errors.length > 0 && !isImporting && (
//             <div className="p-4 border rounded-lg bg-red-900/20 border-red-700/50">
//               <h3 className="mb-2 text-sm font-semibold text-red-400">Validation Errors:</h3>
//               <ul className="overflow-y-auto text-xs text-red-300 list-disc list-inside max-h-32">
//                 {errors.slice(0, 10).map((error, idx) => (
//                   <li key={idx}>{error}</li>
//                 ))}
//                 {errors.length > 10 && <li>...and {errors.length - 10} more errors</li>}
//               </ul>
//             </div>
//           )}

//           {preview.length > 0 && errors.length === 0 && !isImporting && (
//             <div>
//               <h3 className="mb-2 text-sm font-semibold text-blue-300">Preview (First 5 rows):</h3>
//               <div className="overflow-x-auto rounded-lg max-h-48">
//                 <table className="w-full text-xs border bg-richblue-900 border-blue-800/60">
//                   <thead className="sticky top-0 border-b bg-richblue-900 border-blue-800/60">
//                     <tr>
//                       {Object.keys(preview[0]).map(key => (
//                         <th key={key} className="p-2 text-left text-blue-300 whitespace-nowrap">{key}</th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {preview.map((row, idx) => (
//                       <tr key={idx} className="border-b border-blue-800/30">
//                         {Object.values(row).map((value, valIdx) => (
//                           <td key={valIdx} className="p-2 text-gray-300 whitespace-nowrap">{value}</td>
//                         ))}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {!isImporting && (
//             <div className="flex gap-3 pt-2">
//               <button
//                 type="button"
//                 onClick={onClose}
//                 className="flex-1 px-4 py-2.5 rounded-lg border border-blue-800/60 text-blue-300 hover:bg-blue-800/20 transition-colors text-sm font-medium"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 onClick={onImport}
//                 disabled={!csvFile || errors.length > 0}
//                 className="flex-1 px-4 py-2.5 rounded-lg bg-purple-600 hover:bg-purple-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-white text-sm font-semibold flex items-center justify-center gap-2"
//               >
//                 <Upload className="w-4 h-4" /> Import Users
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ImportCSVModal;


import React from 'react';
import { Upload, X } from 'lucide-react';

const ImportCSVModal = ({
  isOpen,
  onClose,
  onImport,
  csvFile,
  onFileUpload,
  isImporting,
  preview,
  errors,
  progress,
  theme
}) => {
  if (!isOpen) return null;

  const isDark = theme === 'dark';

  // Theme-aware classes
  const bgModal = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgHeader = isDark ? 'bg-richblue-950' : 'bg-white';
  //const bgInput = isDark ? 'bg-richblue-900' : 'bg-gray-50';
  const bgPreview = isDark ? 'bg-richblue-900' : 'bg-gray-50';
  const bgInfoBox = isDark ? 'bg-blue-600/10 border-blue-700/50' : 'bg-blue-100/50 border-blue-300';
  const bgErrors = isDark ? 'bg-red-900/20 border-red-700/50' : 'bg-red-100/50 border-red-300';
  
  const borderColor = isDark ? 'border-blue-700/50' : 'border-gray-300';
  const borderLight = isDark ? 'border-blue-800/40' : 'border-gray-200';
  //const borderInput = isDark ? 'border-blue-800/60' : 'border-gray-300';
  const borderPreview = isDark ? 'border-blue-800/60' : 'border-gray-300';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-300' : 'text-gray-700';
  //const textMuted = isDark ? 'text-gray-400' : 'text-gray-500';
  //const textBlue = isDark ? 'text-blue-300' : 'text-blue-700';
  //const textPurple = isDark ? 'text-purple-400' : 'text-purple-600';
  const textError = isDark ? 'text-red-300' : 'text-red-600';
  //const textGray = isDark ? 'text-gray-300' : 'text-gray-700';
  
  const hoverBg = isDark ? 'hover:bg-blue-600/20' : 'hover:bg-gray-100';
  const buttonCancel = isDark 
    ? 'border-blue-800/60 text-blue-300 hover:bg-blue-800/20'
    : 'border-gray-300 text-gray-700 hover:bg-gray-100';
  const buttonImport = isDark
    ? 'bg-purple-600 hover:bg-purple-500'
    : 'bg-purple-500 hover:bg-purple-600';
  const buttonTemplate = isDark
    ? 'bg-purple-600/20 hover:bg-purple-600/40 text-purple-400'
    : 'bg-purple-100 hover:bg-purple-200 text-purple-600';
  
  const fileInputStyles = isDark
    ? 'text-white bg-richblue-900 border-blue-800/60 file:bg-purple-600/20 file:text-purple-400 hover:file:bg-purple-600/40'
    : 'text-gray-900 bg-gray-50 border-gray-300 file:bg-purple-100 file:text-purple-600 hover:file:bg-purple-200';

  const downloadTemplate = () => {
    const csv = "user_name *,user_email,user_phone,user_department,user_roll *,managerId *,shift_start *,shift_end *,timezone,viewtimezone\nJohn Doe,john@company.com,9876543210,CSE,21BTCS0207,manager@email.com,09:00:00,18:00:00,Asia/Calcutta,Asia/Calcutta";
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'user_import_template.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className={`fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 ${isDark ? 'bg-black/50' : 'bg-gray-500/30'} backdrop-blur-sm`} onClick={!isImporting && onClose}>
      <div className={`${bgModal} border ${borderColor} rounded-2xl w-full sm:max-w-4xl max-h-[92vh] overflow-y-auto sm:mb-0 mb-[70px] transition-colors duration-300`} onClick={(e) => e.stopPropagation()}>
        <div className={`sticky top-0 flex items-center justify-between p-5 border-b ${bgHeader} ${borderLight}`}>
          <h2 className={`flex items-center gap-2 text-xl font-bold ${textPrimary}`}>
            <Upload className="w-5 h-5 text-purple-500" /> Import Users from CSV
          </h2>
          <button onClick={onClose} disabled={isImporting} className={`p-2 transition-colors rounded-lg ${hoverBg}`}>
            <X className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-gray-500'}`} />
          </button>
        </div>

        <div className="p-5 space-y-5">
          <div className={`p-4 border rounded-lg ${bgInfoBox} transition-colors duration-300`}>
            <p className={`mb-2 text-sm ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>CSV Format Requirements:</p>
            <p className={`mb-2 text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
              Required columns: user_name, user_ID, managerId, shift_start, shift_end<br />
              Optional columns: user_email, user_phone, user_department, timezone, viewtimezone<br />
              Note: managerId can be Manager Email
            </p>
            <button
              onClick={downloadTemplate}
              className={`px-3 py-1 text-sm transition-colors rounded-lg ${buttonTemplate}`}
            >
              Download CSV Template
            </button>
          </div>

          <div>
            <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Upload CSV File</label>
            <input
              type="file"
              accept=".csv"
              onChange={onFileUpload}
              disabled={isImporting}
              className={`w-full px-4 py-2 text-sm border rounded-lg focus:outline-none ${fileInputStyles} disabled:opacity-50 transition-colors duration-300`}
            />
          </div>

          {isImporting && progress.total > 0 && (
            <div className="space-y-2">
              <div className={`flex justify-between text-sm ${isDark ? 'text-blue-300' : 'text-gray-600'}`}>
                <span>Importing users...</span>
                <span>{progress.current} / {progress.total}</span>
              </div>
              <div className={`w-full h-2 rounded-full ${isDark ? 'bg-richblue-900' : 'bg-gray-200'}`}>
                <div
                  className="h-2 transition-all duration-300 bg-purple-600 rounded-full"
                  style={{ width: `${(progress.current / progress.total) * 100}%` }}
                />
              </div>
            </div>
          )}

          {errors.length > 0 && !isImporting && (
            <div className={`p-4 border rounded-lg ${bgErrors} transition-colors duration-300`}>
              <h3 className={`mb-2 text-sm font-semibold ${textError}`}>Validation Errors:</h3>
              <ul className={`overflow-y-auto text-xs ${isDark ? 'text-red-300' : 'text-red-600'} list-disc list-inside max-h-32`}>
                {errors.slice(0, 10).map((error, idx) => (
                  <li key={idx}>{error}</li>
                ))}
                {errors.length > 10 && <li>...and {errors.length - 10} more errors</li>}
              </ul>
            </div>
          )}

          {preview.length > 0 && errors.length === 0 && !isImporting && (
            <div>
              <h3 className={`mb-2 text-sm font-semibold ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Preview (First 5 rows):</h3>
              <div className="overflow-x-auto rounded-lg max-h-48">
                <table className={`w-full text-xs border ${bgPreview} ${borderPreview} transition-colors duration-300`}>
                  <thead className={`sticky top-0 border-b ${bgPreview} ${borderPreview}`}>
                    <tr>
                      {Object.keys(preview[0]).map(key => (
                        <th key={key} className={`p-2 text-left ${isDark ? 'text-blue-300' : 'text-gray-600'} whitespace-nowrap`}>{key}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {preview.map((row, idx) => (
                      <tr key={idx} className={`border-b ${isDark ? 'border-blue-800/30' : 'border-gray-200'}`}>
                        {Object.values(row).map((value, valIdx) => (
                          <td key={valIdx} className={`p-2 ${isDark ? 'text-gray-300' : 'text-gray-700'} whitespace-nowrap`}>{value}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {!isImporting && (
            <div className="flex gap-3 pt-2">
              <button
                type="button"
                onClick={onClose}
                className={`flex-1 px-4 py-2.5 rounded-lg border ${buttonCancel} transition-colors text-sm font-medium`}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={onImport}
                disabled={!csvFile || errors.length > 0}
                className={`flex-1 px-4 py-2.5 rounded-lg ${buttonImport} disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-white text-sm font-semibold flex items-center justify-center gap-2`}
              >
                <Upload className="w-4 h-4" /> Import Users
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImportCSVModal;
